import { Auth0Client } from "@auth0/auth0-spa-js";
import axios from "axios";
import { apiConfig, auth0Config } from "../../config";
import {
  CreateLocation,
  Location,
  LocationQuery,
  UpdateLocation,
} from "../../types/location";
import querySearchEndpoint from "../../utils/querySearchEndpoint";
import { getAuthConfigWithProps, getBasicAuthConfig } from "../authUtils";

const urlPath = "locations";

class LocationApi {
  private auth0Client: Auth0Client | null = null;

  constructor() {
    this.auth0Client = new Auth0Client({
      redirect_uri: window.location.origin,
      ...auth0Config,
    });
  }

  async getLocation(id: string): Promise<Location> {
    const config = await getBasicAuthConfig(this.auth0Client);
    return axios
      .get(`${apiConfig.providerServiceBase}/${urlPath}/${id}`, config)
      .then((res) => res?.data);
  }

  async getLocations(
    query: LocationQuery,
    signal?: AbortSignal,
  ): Promise<Location[]> {
    const config = await getAuthConfigWithProps(
      this.auth0Client,
      signal ? { signal } : {},
    );

    const url = new URL(`${apiConfig.providerServiceBase}/${urlPath}`);
    return querySearchEndpoint(url, query, config);
  }

  async createLocation(location: CreateLocation): Promise<Location> {
    const config = await getBasicAuthConfig(this.auth0Client);

    return axios
      .post(`${apiConfig.providerServiceBase}/${urlPath}`, location, config)
      .then((res) => res?.data);
  }

  async updateLocation(
    id: string,
    location: UpdateLocation,
  ): Promise<Location> {
    const config = await getBasicAuthConfig(this.auth0Client);
    return axios
      .put(
        `${apiConfig.providerServiceBase}/${urlPath}/${id}`,
        location,
        config,
      )
      .then((res) => res?.data);
  }
}

const locationApi = new LocationApi();

export default locationApi;
